import { EMPTY_GENERAL_CSV_REPORT_MODEL } from "presentation/model/GeneralCsvReport/GeneralCsvReportModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: GeneralCsvReportProvider,
    useTracked: useGeneralCsvReportTracked
} = createContainer(() => useState(EMPTY_GENERAL_CSV_REPORT_MODEL), { concurrentMode: true });
export { GeneralCsvReportProvider, useGeneralCsvReportTracked };

